<page-load-header *ngIf="!initialized"></page-load-header>

<div [hidden]="mapCoordinates.length == 0 || excludeGPS" class="map-container">
  <div id="map" [ngClass]="{ 'modal-map': isModal === true }"></div>
</div>
